import { CS } from "../../../../base/utils/styler";

export const rateTdStyle: CS = {
    height: '60px',
    textAlign: 'center',
    borderBottom: '1px solid #ccc',
    position: 'relative',
    display: 'table-cell',

}